import React from "react";
import Layout from "@/Layout";
import Router from "next/router";
import { get, post } from "$ACTIONS/TlcRequest";
import { LEARN_TIME } from "$ACTIONS/constantsData";
import { Cookie } from "$ACTIONS/util";
import { ApiPort, APISETS, StrapiApi } from "$ACTIONS/TLCAPI";
import { Modal, Row, Col, Tabs, Icon, message, Spin } from "antd";
import {
    getQueryVariable,
    getAffiliateReferralCode,
    Cookie as Cookiehelper,
} from "$ACTIONS/helper";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Banner from "@/Banner";
import QRCode from "qrcode-react";
import LazyLoad from "react-lazyload";
import Announcement from "@/Announcement/";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Bannerimg from "@/Banner/img";
import Image from "next/image";
import { isWebPSupported } from "$ACTIONS/helper";
import ImageWithFallback from "@/ImageWithFallback/imgLocal";
import Superdoor from "@/Home/superdoor";
import { connect } from "react-redux";
import { setSmarticoLoginContinue, checkYBSWhitelistStatus } from "../../store/thunk/gameThunk"

const { TabPane } = Tabs;
class Main extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            bannerList: [],
            isLogin: false,
            isLearn: false,
            downloadLinks: "",
            hostname: "",
            promotionbannerList: "",
            sponsorbannerList: "",
            shopDataState: null,
            showCtcWin: true,
            eightShopLoading: false,
            promotionCurrKey: "0",
            mainShopHref: "",
            announcement: false,
            newsList: {},
        };

        this.homePageSetLockHeader = function () {}; // 锁定Header状态
        this.defaultBannerList = this.defaultBannerList.bind(this); // 默认获取登录前的Banner列表
        this.mainPromotionSplitPage = this.mainPromotionSplitPage.bind(this);
    }
    isJSON(str) {
        if (typeof str == "string") {
            try {
                var obj = JSON.parse(str);
                if (typeof obj == "object" && obj) {
                    return obj;
                } else {
                    return false;
                }
            } catch (e) {
                console.log("error：" + str + "!!!" + e);
                return false;
            }
        }
        console.log("It is not a string!");
    }

    componentDidMount() {
        const isSupportWebp = isWebPSupported() ? "&displaying_webp" : "";

        let loginStatus =
                sessionStorage.getItem("isLogin") &&
                localStorage.getItem("access_token"), //已登录状态
            isRegisterEvent =
                sessionStorage.getItem("isRegisterEvent") &&
                localStorage.getItem("access_token"); //注册登录成功
        !isRegisterEvent &&
            get(
                `${StrapiApi}/zh-hans/api/v1/web/webbanners/position/home_main?login=${
                    loginStatus
                        ? `after${isSupportWebp}`
                        : `before${isSupportWebp}`
                }`
            ).then(this.defaultBannerList);
        this.Downloadidopen();
        setTimeout(() => {
            this.Downloadidopen();
        }, 5000);
        this.setState({
            hostname: window.location.origin,
        });

        const LocalFeature = localStorage.getItem("LocalFeature");
        const LocalSponsor = localStorage.getItem("LocalSponsor");
        const LocalFeatureParse = this.isJSON(LocalFeature),
            LocalSponsorParse = this.isJSON(LocalSponsor);
        LocalFeatureParse &&
            this.setState({ promotionbannerList: LocalFeatureParse });
        LocalSponsorParse &&
            this.setState({ sponsorbannerList: LocalSponsorParse });
        const baseUrl =
            StrapiApi + "/zh-hans/api/v1/web/webbanners/position/home_feature";
        const loginParam = loginStatus
            ? `after${isSupportWebp}`
            : `before${isSupportWebp}`;
        const _url = `${baseUrl}?login=${loginParam}`;
        /* 优惠列表 */
        !isRegisterEvent &&
            get(_url).then((res) => {
                let result = this.formatPromotionListData(res);
                const localStr = JSON.stringify(result);
                localStorage.setItem("LocalFeature", localStr);
                localStr !== LocalFeature &&
                    result &&
                    this.setState({ promotionbannerList: result });
            });

        /* 赞助列表 */
        !isRegisterEvent &&
            get(
                StrapiApi +
                    "/zh-hans/api/v1/web/webbanners/position/home_sponsor?login=" +
                    (loginStatus
                        ? `after${isSupportWebp}`
                        : `before${isSupportWebp}`)
            ).then((res) => {
                const localStr = JSON.stringify(res);
                localStorage.setItem("LocalSponsor", localStr);
                localStr !== LocalSponsor &&
                    res &&
                    this.setState({ sponsorbannerList: res });
            });

        // 按照字符串下标说明依次为（未登录首页，已登录首页，已登录个人中心入口，我的优惠，交易记录，提现，转账）
        let learnStepString = Cookie("learnStep");
        // 初始导引步骤状态
        !learnStepString &&
            Cookie("learnStep", "00000000", { expires: LEARN_TIME });
        // this.setLearnStepStatus();

        // 更改为seesionStorage，强制清除客户端localStorage，隔版本后删除此代码。
        localStorage.removeItem("LocalShopURL");
        global.Pushgtagpiwikurl && global.Pushgtagpiwikurl("home");
        if(!!sessionStorage.getItem("euroEventForEnd")){
            const modals = Modal.info({
                className: "euro-event-end",
                icon: null,
                title: "",
                centered: true,
                okText: null,
                zIndex: 2000,
                width: 600,
                content: (
                    <div className="content">
                        <img src="/cn/img/euro2024/EventEnded-CN_desktop.jpg" />
                        <div 
                            className="okbtn" 
                            onClick={() => {
                                modals.destroy();
                                sessionStorage.removeItem("euroEventForEnd");
                            }}
                        >我知道了</div>
                    </div>
                )
            })
            Pushgtagpiwikurl("euro2024_event_finish","Euro2024 Event Finish");
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isLogin !== this.state.isLogin) {
            const isSupportWebp = isWebPSupported() ? "&displaying_webp" : "";
            this.defaultBannerList = function () {};
            let loginStatus =
                    sessionStorage.getItem("isLogin") &&
                    localStorage.getItem("access_token"), //已登录状态
                isRegisterEvent =
                    sessionStorage.getItem("isRegisterEvent") &&
                    localStorage.getItem("access_token"); //注册登录成功
            !isRegisterEvent &&
                get(
                    StrapiApi +
                        "/zh-hans/api/v1/web/webbanners/position/home_main?login=" +
                        (loginStatus
                            ? `after${isSupportWebp}`
                            : `before${isSupportWebp}`)
                ).then(async (res) => {
                    let formattedRes = res;
                    if (localStorage.getItem('access_token')) {
                        if(!this.props.memberCheckedYBSCalled) {
                            await this.props.checkYBSWhitelist(localStorage.getItem('memberCode'));
                        }
                        formattedRes = res.filter(data => !this.props.gamesToFilter.includes(data.action.cgmsVendorCode));
                    }
                    formattedRes && this.setState({ bannerList: formattedRes });
                });

            const baseUrl =
                StrapiApi +
                "/zh-hans/api/v1/web/webbanners/position/home_feature";
            const loginParam = loginStatus ? "after" : "before";

            const getimgurl = `${baseUrl}?login=${loginParam}${isSupportWebp}`;
            /* 优惠列表 */
            !isRegisterEvent &&
                get(getimgurl).then((res) => {
                    let result = this.formatPromotionListData(res);
                    const localStr = JSON.stringify(result);
                    localStorage.setItem("LocalFeature", localStr);
                    this.setState({ promotionbannerList: result });
                });

            /* 赞助列表 */
            !isRegisterEvent &&
                get(
                    StrapiApi +
                        "/zh-hans/api/v1/web/webbanners/position/home_sponsor?login=" +
                        (loginStatus
                            ? `after${isSupportWebp}`
                            : `before${isSupportWebp}`)
                ).then((res) => {
                    const localStr = JSON.stringify(res);
                    localStorage.setItem("LocalSponsor", localStr);
                    this.setState({ sponsorbannerList: res });
                });
        }
    }

    /**
     * 根据单页长度，按照几个长度进行分页，格式化响应的精彩活动
     * @param {Array} res 需要处理分页的数据
     * @param {Int} singlePageSize 单页需要展示的长度
     * @param {Int} splitPageSize 实际分页的参考长度
     * @returns 转换后的结果
     */
    formatPromotionListData(res, singlePageSize = 3, splitPageSize = 2) {
        let result = [];
        let len = res && Math.ceil(res.length / splitPageSize);

        for (let i = 0; i < len; i++) {
            let tempIndex = i * splitPageSize; // 当前页起始下标
            let tempPageData = []; // 当前下标数据暂存值
            for (let j = 0; j < singlePageSize; j++) {
                const tempData = res[tempIndex + j]; // 当前页单个数据暂存值
                !!tempData && tempPageData.push(tempData);
            }
            result.push(tempPageData);
        }

        return result;
    }

    defaultBannerList(res) {
        res && this.setState({ bannerList: res });
    }

    Downloadidopen() {
        const affcode = getAffiliateReferralCode(),
            disabled =
                Cookiehelper.GetCookieKeyValue("CO_affiliate") != "undefined" &&
                Cookiehelper.GetCookieKeyValue("CO_affiliate") != "";
        const url = `${window.location.origin}/cn/Appinstall.html${
            disabled ? "?affCode=" + affcode : ""
        }`;
        global.downloadLinks = url;
        this.setState({ downloadLinks: url });
    }

    // 前往指定的充值方式
    goDepositModal() {
        if (!localStorage.getItem("access_token")) {
            global.goUserSign("1");
            return;
        }

        global.showDialog({
            key: 'wallet:{"type": "deposit", "currentPayValue": "CTC"}',
        });
    }
    // 首页精彩活动翻页
    mainPromotionSplitPage(direction) {
        const { promotionCurrKey, promotionbannerList } = this.state;
        const currKey = parseInt(promotionCurrKey);
        direction === "up" &&
            currKey > 0 &&
            this.setState({ promotionCurrKey: (currKey - 1).toString() });
        direction === "down" &&
            currKey < promotionbannerList.length - 1 &&
            this.setState({ promotionCurrKey: (currKey + 1).toString() });
    }
    render() {
        const { promotionbannerList, sponsorbannerList, shopDataState } =
            this.state;
        return (
            <Layout
                isIndexPage={true}
                title="亚洲首选体育平台，英超热刺纽卡赞助伙伴 "
                Keywords="英超俱乐部赞助商/NBA球星代言娱乐平台/托特纳姆热刺赞助伙伴/纽卡斯尔赞助伙伴/伯恩利官方球衣赞助商/托尼帕克品牌大使/卡西利亚斯品牌大使/科比布莱恩品牌大使/史蒂夫纳什品牌大使/罗比福勒桑德兰品牌大使/刀塔OG战队赞助商"
                description="拥有13年历史实力品牌，NBA球星联合推荐、英超俱乐部合作伙伴，提供最全五大足球联赛等体育赛事，以及多样化游戏娱乐项目，迎战欧洲杯最佳首选APP。"
                headerHeightLock={this.state.isLearn}
                setLoginStatus={(v) => {
                    this.setState({ isLogin: v });
                }}
                setLockHeader={(setLockHeader) => {
                    this.homePageSetLockHeader = setLockHeader;
                }}
                setShopURL={(result) => {
                    this.setState({ shopDataState: result });
                }}
            >
                {/* Banner 图片 */}
                <Banner
                    // bannerClick={this.bannerClick}
                    bannerList={this.state.bannerList}
                />
                {/* 主体内容区域 */}
                <div className="common-distance-wrap">
                    {/* ------------ 註冊成功彈窗 ------------*/}
                    <ToastContainer />

                    <div className="common-distance">
                        {Array.isArray(sponsorbannerList) &&
                            sponsorbannerList.length != 0 && (
                                <React.Fragment>
                                    {" "}
                                    <h2 className="home-section-title">
                                        优惠
                                    </h2>
                                    {sponsorbannerList != "" &&
                                    Array.isArray(sponsorbannerList) ? (
                                        <Tabs
                                            type="card"
                                            className="home-promotion-wrap _2 promotionBanner"
                                        >
                                            {sponsorbannerList.map(
                                                (item, index) => {
                                                    return (
                                                        <TabPane
                                                            tab={
                                                                <div
                                                                    className="home-sponsor offset-y"
                                                                    onClick={() => {
                                                                        Pushgtagdata(
                                                                            "Banner",
                                                                            "Click",
                                                                            item.title +
                                                                                "_Sponsorship_Home"
                                                                        );
                                                                    }}
                                                                >
                                                                    <LazyLoad
                                                                        height={
                                                                            120
                                                                        }
                                                                    >
                                                                        <Bannerimg
                                                                            item={
                                                                                item
                                                                            }
                                                                            width={
                                                                                540
                                                                            }
                                                                            height={
                                                                                119
                                                                            }
                                                                        />
                                                                    </LazyLoad>
                                                                </div>
                                                            }
                                                            key={index}
                                                        />
                                                    );
                                                }
                                            )}
                                        </Tabs>
                                    ) : (
                                        <div className="ant-skeleton ant-skeleton-active">
                                            <div className="ant-skeleton-content">
                                                <ul className="ant-skeleton-paragraph">
                                                    <li
                                                        style={{ height: 133 }}
                                                    />
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </React.Fragment>
                            )}

                        {Array.isArray(promotionbannerList) &&
                            promotionbannerList.length != 0 && (
                                <React.Fragment>
                                    {" "}
                                    <h2 className="home-section-title featured-activities">
                                        <span>精彩活动</span>
                                        <div
                                            className="home-split-page-btn-wrap"
                                            style={{
                                                display:
                                                    promotionbannerList != "" &&
                                                    Array.isArray(
                                                        promotionbannerList
                                                    ) &&
                                                    promotionbannerList.length >
                                                        1
                                                        ? "block"
                                                        : "none",
                                            }}
                                        >
                                            {this.state.promotionCurrKey !=
                                            0 ? (
                                                <span
                                                    onClick={() => {
                                                        this.mainPromotionSplitPage(
                                                            "up"
                                                        );
                                                    }}
                                                    unselectable="unselectable"
                                                    className="ant-tabs-tab-prev ant-tabs-tab-arrow-show"
                                                >
                                                    <span className="ant-tabs-tab-prev-icon">
                                                        <i
                                                            aria-label="图标: left"
                                                            className="anticon anticon-left ant-tabs-tab-prev-icon-target"
                                                        >
                                                            <svg
                                                                viewBox="64 64 896 896"
                                                                focusable="false"
                                                                className=""
                                                                data-icon="left"
                                                                width="1em"
                                                                height="1em"
                                                                fill="currentColor"
                                                                aria-hidden="true"
                                                            >
                                                                <path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" />
                                                            </svg>
                                                        </i>
                                                    </span>
                                                </span>
                                            ) : null}
                                            {promotionbannerList &&
                                            promotionbannerList.length &&
                                            promotionbannerList.length - 1 !=
                                                this.state.promotionCurrKey ? (
                                                <span
                                                    onClick={() => {
                                                        this.mainPromotionSplitPage(
                                                            "down"
                                                        );
                                                    }}
                                                    unselectable="unselectable"
                                                    className="ant-tabs-tab-next ant-tabs-tab-arrow-show"
                                                >
                                                    <span className="ant-tabs-tab-next-icon">
                                                        <i
                                                            aria-label="图标"
                                                            className="anticon anticon-right ant-tabs-tab-next-icon-target"
                                                        >
                                                            <svg
                                                                viewBox="64 64 896 896"
                                                                focusable="false"
                                                                className=""
                                                                data-icon="right"
                                                                width="1em"
                                                                height="1em"
                                                                fill="currentColor"
                                                                aria-hidden="true"
                                                            >
                                                                <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z" />
                                                            </svg>
                                                        </i>
                                                    </span>
                                                </span>
                                            ) : null}
                                        </div>
                                    </h2>
                                    {promotionbannerList != "" &&
                                    Array.isArray(promotionbannerList) ? (
                                        <div>
                                            <Tabs
                                                className="home-split-page-promotion-wrap"
                                                activeKey={
                                                    this.state.promotionCurrKey
                                                }
                                            >
                                                {promotionbannerList.map(
                                                    (item, index) => {
                                                        return (
                                                            <TabPane
                                                                tab={null}
                                                                key={index}
                                                            >
                                                                {item.map(
                                                                    (
                                                                        panelItem,
                                                                        panelIndex
                                                                    ) => {
                                                                        return (
                                                                            <div
                                                                                key={
                                                                                    "panel" +
                                                                                    panelIndex
                                                                                }
                                                                                className="home-promotion offset-y"
                                                                                onClick={() => {
                                                                                    if (
                                                                                        panelItem.title ===
                                                                                        "WEC Feature Banner"
                                                                                    ) {
                                                                                        Pushgtagdata(
                                                                                            `FeatureBanner`,
                                                                                            "Click",
                                                                                            `${panelItem.action.cgmsVendorCode}_FeatureBanner_Home`
                                                                                        );
                                                                                        return;
                                                                                    }
                                                                                    if (panelItem.title === "Smartico banner") {      
                                                                                        this.props.setSmarticoContinue(true)
                                                                                    }
                                                                                    Pushgtagdata(
                                                                                        'Home',
                                                                                        'Click Feature Banner',
                                                                                        'Home_C_FeatureBanner',
                                                                                        'Home_C_FeatureBanner_ActivityName',
                                                                                        panelItem.title
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <LazyLoad
                                                                                    height={
                                                                                        100
                                                                                    }
                                                                                    offset={
                                                                                        100
                                                                                    }
                                                                                    once
                                                                                >
                                                                                    <Bannerimg
                                                                                        item={
                                                                                            panelItem
                                                                                        }
                                                                                        width={
                                                                                            480
                                                                                        }
                                                                                        height={
                                                                                            100
                                                                                        }
                                                                                    />
                                                                                </LazyLoad>
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </TabPane>
                                                        );
                                                    }
                                                )}
                                            </Tabs>
                                        </div>
                                    ) : (
                                        <div className="ant-skeleton ant-skeleton-active">
                                            <div className="ant-skeleton-content">
                                                <ul className="ant-skeleton-paragraph">
                                                    <li
                                                        style={{ height: 116 }}
                                                    />
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </React.Fragment>
                            )}
                    </div>
                </div>
                <div className="common-distance-wrap app-qrcode-wrap">
                    <div className="common-distance">
                        <Row gutter={20}>
                            <Col span={9}>
                                <LazyLoad height={401} offset={100} once>
                                    <div className="app-picture">
                                        {/* <img
                                            src="/cn/img/home/part/AppDownloadSection.webp"
                                            alt="app-picture"
                                        /> */}
                                        <div className="AppDownloadSection">
                                            <ImageWithFallback
                                                src={`/cn/img/home/part/AppDownloadSection_2023.${
                                                    isWebPSupported()
                                                        ? "webp"
                                                        : "png"
                                                }`}
                                                width={401}
                                                height={382}
                                                alt="app-picture"
                                            />
                                        </div>
                                    </div>
                                </LazyLoad>
                            </Col>
                            <Col span={14}>
                                <Row className="qrcode">
                                    <Col span={13}>
                                        <h1 className="title">APP 下载</h1>
                                        <div className="qrcode-article-wrap">
                                            <p className="qrcode-article">
                                                乐天使团队倾情打造，业内最顶尖的体育游戏APP。包含体育、电竞、真人、水果机游戏、棋牌等数万种游戏玩法应有尽有。全站游戏适应所有移动设备，精彩游戏畅享指尖！
                                            </p>
                                            <i className="tlc-sprite app-down-icons" />
                                            <h4>手机浏览器输入网址：</h4>
                                            <CopyToClipboard
                                                text={this.state.downloadLinks}
                                                onCopy={() => {
                                                    message.success(
                                                        "复制成功！"
                                                    );
                                                    Pushgtagdata(
                                                        "TLCmobileweb_homepage"
                                                    );
                                                }}
                                            >
                                                <div className="homeinstallurl">
                                                    {this.state.downloadLinks}
                                                    <img
                                                        src="/cn/img/icons/copy.svg"
                                                        className="copy-icon"
                                                        alt="copy"
                                                    />
                                                </div>
                                            </CopyToClipboard>
                                        </div>
                                    </Col>
                                    <Col span={6} offset={1}>
                                        <div className="App-Qrcode-List">
                                            <LazyLoad
                                                height={175}
                                                offset={100}
                                                once
                                            >
                                                <div className="qrcode-picture">
                                                    {this.state
                                                        .downloadLinks ? (
                                                        <QRCode
                                                            //logo={'/cn/img/download/qrlogo.jpg'}
                                                            size={148}
                                                            value={
                                                                this.state
                                                                    .downloadLinks
                                                            }
                                                            // logoWidth={50}
                                                            // logoHeight={50}
                                                        />
                                                    ) : null}
                                                    <h5 className="App-Name">
                                                        手机扫码下载 APP
                                                    </h5>
                                                </div>
                                            </LazyLoad>
                                            <LazyLoad
                                                height={175}
                                                offset={100}
                                                once
                                            >
                                                <div className="qrcode-picture">
                                                    {this.state
                                                        .downloadLinks ? (
                                                        <QRCode
                                                            //logo={'/cn/img/download/qrlogo.jpg'}
                                                            size={148}
                                                            value={
                                                                this.state
                                                                    .downloadLinks
                                                            }
                                                            // logoWidth={50}
                                                            // logoHeight={50}
                                                        />
                                                    ) : null}
                                                    <h5 className="App-Name">
                                                        手机扫码下载 CS APP
                                                    </h5>
                                                </div>
                                            </LazyLoad>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>

                {/* 紧急公告弹窗 */}
                <Announcement/>
                
                {/* 测速网站 */}
                {this.state.isLogin && <Superdoor/>}
            </Layout>
        );
    }
}

const mapStateToProps = function(state) {
	return {
		gamesToFilter: state.game.gamesToFilter,
        memberCheckedYBSCalled: state.game.memberCheckedYBSCalled,
	};
}

const mapDispatchToProps = function (dispatch) {
    return {
        setSmarticoContinue: (isFromSmarticoLogin) => {
            dispatch(setSmarticoLoginContinue(isFromSmarticoLogin));
        },
        checkYBSWhitelist: async (memberCode) => {
            await dispatch(checkYBSWhitelistStatus(memberCode));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Main);
